export type RequestStatus = 'idle' | 'pending' | 'success' | 'error';

export function requestErrorMessage(error: unknown, fallback: string): string {
    return error instanceof Error && error.message ? error.message : fallback;
}
